export default "__VITE_ASSET__gDW11xsh__"